var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "p-6 flex flex-col gap-5",
      attrs: { id: "center-client-acquisition" }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "p-6 flex items-center justify-between gap-4 bg-pure-white rounded-3xl border border-slate-400"
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-col gap-2" },
            [
              _c("BlTextTitle4", { attrs: { text: "Parents' Form" } }),
              _vm._v(" "),
              _c("BlTextBody2", {
                attrs: {
                  text: "Customize and edit the questions in the parents' form."
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "router-link",
            { attrs: { to: "/center/client-acquisition/form" } },
            [_c("BlInputButton", { attrs: { label: "View form" } })],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "p-6 flex items-center justify-between gap-4 bg-pure-white rounded-3xl border border-slate-400"
        },
        [
          _c(
            "div",
            { staticClass: "flex flex-col gap-2" },
            [
              _c("BlTextTitle4", { attrs: { text: "Tags" } }),
              _vm._v(" "),
              _c("BlTextBody2", {
                attrs: {
                  text:
                    "These tags will only be visible during the client acquisition process, and their data can be visualized in the data analytics."
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "router-link",
            { attrs: { to: "/repository?tab=prospect" } },
            [_c("BlInputButton", { attrs: { label: "View tags" } })],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e3f1fa3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e3f1fa3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/CenterClientAcquisition.vue
// module id = null
// module chunks = 